import styled from "@emotion/styled";
import { SelectField, SelectFieldProps } from "@kaltura/mediaspace-shared-ui";
import { LabelledValue } from "@kaltura/mediaspace-shared-types";
import { KalturaRecordStatus } from "kaltura-typescript-client/api/types/KalturaRecordStatus";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface RecordingModeProps extends Omit<SelectFieldProps, "value" | "options"> {
    value: KalturaRecordStatus;
}

const StyledWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
}));

const baseClassName = "kms-ds-recording-mode";

const options: LabelledValue[] = [
    { value: KalturaRecordStatus.disabled, label: translate("Disable recording for this session") },
    { value: KalturaRecordStatus.appended, label: translate("Append recorded content to a single entry") },
    { value: KalturaRecordStatus.perSession, label: translate("Export each broadcast to a VOD entry") },
];

/**
 * Recording mode selector - a dropdown to choose how recordings are saved for a live event.
 */
export const RecordingMode = ({ className = "", value, ...props }: RecordingModeProps) => {
    return (
        <StyledWrapper className={`${className} ${baseClassName}`}>
            <SelectField
                className={`${baseClassName}-select`}
                value={String(value)}
                options={options}
                fontWeightBold={true}
                descriptionTooltip={false}
                {...props}
            />
        </StyledWrapper>
    );
};
